import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import Link from "next/link";
import { LayoutLegacy } from "@silvertours/front-legacy-entities";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { useTranslations } from "next-intl";
import { FooterBaseContent, FooterList, FooterContainer } from "./Page.styles";
var LinkWrapper = function(param) {
    var item = param.item, children = param.children;
    var external = Object.prototype.hasOwnProperty.call(item, "external") && item.external;
    // links marked as 'external' use the standard anchor tag
    // instead of the Link component provided by next.js
    return external ? children : /*#__PURE__*/ _jsx(Link, {
        passHref: true,
        href: item.href,
        children: children
    });
};
var PageFooter = function(param) {
    var _showLogo = param.showLogo, showLogo = _showLogo === void 0 ? true : _showLogo;
    var scrollToTop = function() {
        if ("object" !== "undefined") {
            window.scrollTo(0, 0);
        }
    };
    var t = useTranslations("features.navigationLegacy.footer");
    var links = t.raw("links");
    var logo = t("logo");
    return /*#__PURE__*/ _jsx(LayoutLegacy.FooterSegment, {
        id: "page-footer",
        children: /*#__PURE__*/ _jsxs(FooterContainer, {
            children: [
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    onClick: scrollToTop,
                    "aria-label": "back to top",
                    children: /*#__PURE__*/ _jsx(UiLegacy.SvgIcon, {
                        name: "arrowUp"
                    })
                }),
                /*#__PURE__*/ _jsxs(FooterBaseContent, {
                    children: [
                        /*#__PURE__*/ _jsx(FooterList, {
                            role: "menu",
                            children: links.map(function(item) {
                                return /*#__PURE__*/ _jsx("li", {
                                    role: "presentation",
                                    children: /*#__PURE__*/ _jsx(LinkWrapper, {
                                        item: item,
                                        children: /*#__PURE__*/ _jsx("a", {
                                            href: item.href,
                                            rel: item.rel,
                                            target: item.target,
                                            role: "menuitem",
                                            children: item.text
                                        })
                                    })
                                }, "footer-".concat(item.href));
                            })
                        }),
                        showLogo && /*#__PURE__*/ _jsx(UiLegacy.ImageSVG, {
                            name: logo
                        })
                    ]
                })
            ]
        })
    });
};
export { PageFooter };
